import api from '../../utils/api';

export const ACTION_STUDENT_LOCATION = "ACTION_STUDENT_LOCATION";
export const GOT_LOGINS = 'GOT_LOGINS';

function gotLogins(logins){
    return {
        type: GOT_LOGINS,
        payload: logins
    }
}

export function GetLogins(user, token){
    return (dispatch) => {
        api.GetLogins(user, token, res => {
            dispatch(gotLogins(res.data));
        });
    }
}

/**
 * action for get user location and user ip
 */
export function getLocationStudent() {
    return dispatch => {
        fetch('http://freegeoip.net/json/')
            .then(response => {
                if (response.ok)
                    return response.json();
                response.text().then(data => {
                    const {status, statusText} = response;
                    const message = `HTTP status ${status} (${statusText}): ${data}`;
                    throw new Error(message);
                });
            }).then(data => {
            return dispatch({
                type: ACTION_STUDENT_LOCATION,
                payload: {
                    ...data
                }
            });
        }).catch(error => console.error(error));
    }
}




// WEBPACK FOOTER //
// ./src/store/actions/studentActions.js